module.exports = __webpack_public_path__ + "static/media/price.ee9d1d20.png";